import React, { Component } from 'react'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Sort from 'lib/psfs/Sort'
import Column from 'types/table/Column'

class MaterialTableHead extends Component {
  render() {
    const { formatMessage, columns, actions, sort, tableHeadRef } = this.props
    const onSortChange = (field, order) => () => {
      sort.onSortChange(field, order === Sort.ASC ? Sort.DESC : Sort.ASC)
    }

    if (actions.size > 0 && !columns.hasByProp('field', '__actions__')) {
      columns.add(
        new Column('__actions__', formatMessage({ id: 'actions' }), {
          cellClassName: 'actions-column',
        }),
      )
    }

    return (
      <TableHead ref={tableHeadRef} className="table-head">
        <TableRow>
          {[...columns].map(
            (
              {
                enabled,
                sorting,
                field,
                styles,
                cellClassName,
                title,
                defaultSort,
                defaultSortOrder,
              },
              key,
            ) => {
              if (!enabled) {
                return null
              }

              if (!sort || !sorting) {
                const cellKey = field || key

                return (
                  <TableCell
                    key={cellKey}
                    style={styles}
                    className={cellClassName}>
                    {title}
                  </TableCell>
                )
              }

              if (defaultSort && !sort.field) {
                sort.field = field
                sort.order = defaultSortOrder
              }

              const activeSort = sort.field === field

              return (
                <TableCell
                  key={key}
                  sortDirection={activeSort ? sort.order : false}
                  style={styles}
                  className={cellClassName}>
                  <TableSortLabel
                    href="#"
                    active={activeSort}
                    direction={sort.order}
                    onClick={onSortChange(field, sort.order)}>
                    {title}
                  </TableSortLabel>
                </TableCell>
              )
            },
          )}
        </TableRow>
      </TableHead>
    )
  }
}

export default MaterialTableHead
